import { Button, Divider, Menu, MenuItem } from '@mui/material'
import { FunctionComponent, MouseEvent, useState } from 'react'
import { useAuthActions, useTenantsState } from '@frontegg/react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const SwitchActiveTenant: FunctionComponent = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { switchTenant } = useAuthActions()
  const { activeTenant, tenants } = useTenantsState()

  const open = Boolean(anchorEl)
  const shouldShowTenantMenu = tenants?.length > 1
  const inactiveTenants = tenants.filter((tenant) => tenant.tenantId !== activeTenant?.tenantId)

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleSwitchTenant = (tenantId: string) => {
    switchTenant({ tenantId })
    handleClose()
  }

  return (
    <>
      {shouldShowTenantMenu && (
        <>
          <Divider
            variant="middle"
            orientation="vertical"
            sx={{ bgcolor: 'white', opacity: '20%', height: 28, alignSelf: 'center', width: 1.5 }}
            flexItem
          />

          <Button
            id="switch-tenant-button"
            aria-controls={open ? 'switch-tenant-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{ color: 'inherit', fontSize: 'inherit', px: 0 }}
            data-testid="switch-tenant-button"
          >
            {activeTenant?.name}
          </Button>
          <Menu
            id="switch-tenant-menu"
            MenuListProps={{
              'aria-labelledby': 'switch-tenant-button'
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
          >
            {inactiveTenants.map(({ name, tenantId }) => (
              <MenuItem key={tenantId} onClick={() => handleSwitchTenant(tenantId)}>
                {name}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </>
  )
}

export default SwitchActiveTenant
